import '@wix/design-system/styles.global.css';
import './embed.css';
import { DIGORWrapper } from './DIGORWrapper';
import React from 'react';
import ReactDOM from 'react-dom';
import { clog } from '@/utils/clog';
import { createDivAndAppend, getConfigFromDigorScripts } from './embed-utils';

if (!window.React) {
  console.error('DIGOR: React not found');
}

if (!window.ReactDOM) {
  console.error('DIGOR: ReactDOM not found');
}

(async () => {
  clog('digor-embed: embed script loaded');

  const config = getConfigFromDigorScripts();

  clog('digor-embed: final config', config);

  const parentSelector = config?.parentSelector;
  const digorRoot = createDivAndAppend('digor-root', parentSelector);

  clog('digor-embed: rendering DIGORWrapper', config);

  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(<DIGORWrapper {...config} />, digorRoot);
})();
